module.exports = __webpack_public_path__ + "static/media/scannell-logo-charcoal.0652001c.svg";